export default __webpack_public_path__ + "static/media/pass-driver.0f0b9c9d.png";